<twc-popup #popup caption="{{caption | translate }}" type="primary" width="l">
    <twc-popup-content>
        <form class="twc-form" [formGroup]="editForm">
            <div class="twc-form-control">
                <label class="twc-form-label">
                    {{'OBJECT_EDIT.NAME' | translate }}
                    <div class="twc-form-element">
                        <input twcInput formControlName="name" [pattern]="nameRegex" [maxlength]="nameDescMaxLength">
                    </div>
                </label>
            </div>

            <div class="twc-form-control">
                <label class="twc-form-label">
                    {{'OBJECT_EDIT.DESCRIPTION' | translate }}
                    <div class="twc-form-element">
                        <textarea twcTextarea formControlName="description" [maxlength]="nameDescMaxLength"></textarea>
                    </div>
                </label>
            </div>
            <div class="twc-form-control" *ngIf="canEditCoordinate">
                <label class="twc-form-label">
                    {{ 'OBJECT_EDIT.COORDINATE' | translate }}
                    <div class="twc-form-element">
                        <cw-crs-search placeholder="{{'OBJECT_EDIT.PLACEHOLDER_COORDINATE' | translate}}" type="crs"
                            [selectItem]="editForm.controls.horizProjectionEPSG.value" [floating]="true"
                            (selectItemChange)="setSelectedCRS($event)"></cw-crs-search>
                    </div>
                </label>
            </div>
            <div class="twc-form-control" *ngIf="canEditGeoid">
                <label class="twc-form-label">
                    {{ 'PROJECTS.GEOID' | translate }}
                    <div class="twc-form-element">
                        <cw-crs-search placeholder="{{'CREATE_PROJECT.PLACEHOLDER_GEOID' | translate}}" type="geoid"
                            [selectItem]="editForm.controls.geoid.value" [floating]="true"
                            (selectItemChange)="setSelectedGeoid($event)"></cw-crs-search>
                    </div>
                </label>
            </div>

            <div class="twc-form-control" *ngIf="canEditCaptureDate">
                <label class="twc-form-label">
                    {{ 'CREATE_PROJECT.CAPTURE_DATE' | translate }}
                    <div class="twc-form-element">
                        <twc-date-picker [maxDate]="today">
                            <input twcInputDate formControlName="captureDate">
                        </twc-date-picker>
                    </div>
                </label>
            </div>
        </form>
    </twc-popup-content>


    <twc-popup-footer>
        <button class="twc-button twc-button-link" (click)="popup.onClose()">{{ 'GENERAL.CANCEL' | translate }}</button>
        <button class="twc-button twc-button-primary" [twcLoading]="!!(isLoading$ | async)" (click)="update()"
            [attr.disabled]="!editForm.valid || null">{{'OBJECT_EDIT.SAVE' | translate }}</button>
    </twc-popup-footer>
</twc-popup>